/*
  COREEX cart reservation timer.

  Counts down a "your cart is reserved for MM:SS" clock in the cart drawer.
  Per-visitor and persistent: the end time is stored in localStorage keyed by
  the reset key, so it survives page changes and reloads. On reaching zero it
  loops back to a full duration, keeping the urgency alive.

  ONE global interval re-queries the DOM every tick and reads the end time from
  localStorage — so it does not matter that Focal re-renders the whole mini-cart
  (and thus the timer element) whenever the cart changes. Nothing is bound to a
  specific element instance.
*/
(function () {
  'use strict';

  if (window.__coreexCartTimer) return;
  window.__coreexCartTimer = true;

  function two(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function format(totalSeconds) {
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return two(m) + ':' + two(s);
  }

  function endTimeFor(el) {
    var mins = parseFloat(el.getAttribute('data-minutes')) || 5;
    var key = 'coreex-cart-timer-' + (el.getAttribute('data-key') || 'v1');
    var now = Date.now();
    var end;

    try {
      var stored = localStorage.getItem(key);
      end = stored ? parseInt(stored, 10) : 0;
      // Missing or already elapsed -> start a fresh reservation (loop).
      if (!end || end <= now) {
        end = now + mins * 60000;
        localStorage.setItem(key, end);
      }
    } catch (e) {
      // localStorage blocked (private mode) -> non-persistent fallback
      end = now + mins * 60000;
    }

    return end;
  }

  function tick() {
    var el = document.querySelector('[data-coreex-cart-timer]');
    if (!el) return;

    var display = el.querySelector('[data-coreex-cart-timer-display]');
    if (!display) return;

    var remaining = Math.max(0, Math.round((endTimeFor(el) - Date.now()) / 1000));
    display.textContent = format(remaining);
  }

  tick();
  setInterval(tick, 1000);
})();
